import { useContext as _useContext } from 'react'
import { context } from '~/layouts'

const useContext = () => _useContext(context)

export default useContext
